import React from 'react';
export function AffiliationsSection() {
  const affiliates = [{
    src: 'https://drwzpk38qkpfb.cloudfront.net/www.fentonlakes.com/uploaded/images/Redesign/Layer%2010.png',
    alt: 'Affiliate Partner'
  }, {
    src: 'https://drwzpk38qkpfb.cloudfront.net/www.fentonlakes.com/uploaded/images/Redesign/Layer%2017.png',
    alt: 'Affiliate Partner'
  }, {
    src: 'https://drwzpk38qkpfb.cloudfront.net/www.fentonlakes.com/uploaded/images/Redesign/Layer%2011.png',
    alt: 'Affiliate Partner'
  }, {
    src: 'https://drwzpk38qkpfb.cloudfront.net/www.fentonlakes.com/uploaded/images/Redesign/Layer%2012.png',
    alt: 'Affiliate Partner'
  }, {
    src: 'https://drwzpk38qkpfb.cloudfront.net/www.fentonlakes.com/uploaded/images/Redesign/Layer%2013.png',
    alt: 'Affiliate Partner'
  }, {
    src: 'https://drwzpk38qkpfb.cloudfront.net/www.fentonlakes.com/uploaded/images/Redesign/Layer%2014.png',
    alt: 'Affiliate Partner'
  }, {
    src: 'https://drwzpk38qkpfb.cloudfront.net/www.fentonlakes.com/uploaded/images/Redesign/Layer%2015.png',
    alt: 'Affiliate Partner'
  }, {
    src: 'https://drwzpk38qkpfb.cloudfront.net/www.fentonlakes.com/uploaded/images/Redesign/Layer%2016.png',
    alt: 'Affiliate Partner'
  }];
  return <section className="w-full py-10 md:py-12" style={{
    backgroundColor: '#2d5a3d'
  }} aria-label="Affiliations and Partners" data-id="element-1643">
      <div className="max-w-6xl mx-auto px-4 md:px-8" data-id="element-1644">
        <p className="text-center text-xs font-bold uppercase tracking-widest mb-8" style={{
        color: 'rgba(200,168,75,0.9)',
        fontFamily: 'Inter, sans-serif'
      }} data-id="element-1645">
          Affiliations &amp; Partners
        </p>
        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6" data-id="element-1646">
          {affiliates.map((affiliate, i) => <div key={i} className="flex items-center justify-center rounded-xl p-3" style={{
          backgroundColor: '#f8f6f0',
          height: '72px',
          width: '112px',
          flexShrink: 0
        }} data-id="element-1647">
              <img src={affiliate.src} alt={affiliate.alt} style={{
            maxHeight: '48px',
            maxWidth: '88px',
            width: 'auto',
            height: 'auto',
            objectFit: 'contain',
            display: 'block'
          }} data-id="element-1648" />
            </div>)}
        </div>
      </div>
    </section>;
}